import React from 'react';
import { hot } from 'react-hot-loader';
import Slider from '../../../hocs/Slider/Slider';
import { purifier } from '../../../utils/dom';
import { translate, translateObjectData } from '../../../utils/locale';
import s from './ReviewSlider.scss';

const ReviewSlider = ({ content, setup }) => (
	<div className={s.reviewSlider}>
		<Slider autoplay={2500} showArrows={false}>
			{
				content.reviews.map((r) => {
					const translatedLink = translateObjectData(setup, r.link);
					return (
						<figure key={r.key} className={s.review}>
							<blockquote className={s.review_content}>
								<span className={s.review_content_text} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, r.review)) }} />
							</blockquote>
							{
								r.reviewer && (
									<figcaption className={s.review_reviewer}>
										{ translatedLink.text && <a href={translatedLink.text.url} target="_blank" rel="noopener noreferrer">{`— ${r.reviewer} (${translatedLink.text.title})`}</a> }
										{ !translatedLink.text && <span>{`— ${r.reviewer}`}</span> }
									</figcaption>
								)
							}
						</figure>
					);
				})
			}
		</Slider>
	</div>
);

export default hot(module)(ReviewSlider);
